import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import logoRunergy from '../../assets/images/logo_runergy.png'
import eldenRing from '../../assets/images/eldenring.jpeg'
import spyfallImg from '../../assets/images/spyfall.png'

const Portfolio = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  
  // Set this to false later
  const isUnderConstruction = true

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
    return () => clearTimeout(timeout)
  }, [])

  const portfolioItems = [
    {
      name: 'Runergy',
      description: 'A full-stack fitness application, React + Vite + Node.js + Express + MySQL 8',
      image: logoRunergy,
      url: 'https://github.com/uzii9/Runergy-main'
    },
    {
      name: 'Elden Ring Rune script',
      description: 'Elden ring Rune Automation farm GPC + C + Zenstudio',
      image: eldenRing,
      url: 'https://github.com/uzii9/elden-ring-ps5-auto-farm'
    },
    {
      name: 'Spyfall Online',
      description: 'Spyfall - React + Node.js + Socket.io',
      image: spyfallImg,
      url: 'https://spy-fall.online/',
      github: 'https://github.com/uzii9/Spyfall'
    }
  ]

  return (
    <>
      <div className="container portfolio-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['P', 'o', 'r', 't', 'f', 'o', 'l', 'i', 'o']}
              idx={15}
            />
          </h1>
          {isUnderConstruction ? (
            <div className="under-construction">
              <div className="construction-content">
                <div className="construction-icon">🚧</div>
                <h2>Under Construction</h2>
                <p>This section is currently being updated with new projects and improvements.</p>
                <p>Please check back soon!</p>
              </div>
            </div>
          ) : (
            <div className="images-container">
              {portfolioItems.map((item, idx) => (
                <div className="image-box" key={idx}>
                  {item.isComingSoon ? (
                    <div className="coming-soon-placeholder">
                      <span className="coming-soon-text">Coming Soon</span>
                    </div>
                  ) : (
                    <img 
                      src={item.image}
                      className="portfolio-image"
                      alt={item.name}
                    />
                  )}
                  <div className="content">
                    <p className="title">{item.name}</p>
                    <h4 className="description">{item.description}</h4>
                    <div className="button-group">
                      {item.github ? (
                        <>
                          <button
                            className="btn"
                            onClick={() => window.open(item.url)}
                          >
                            Live Demo
                          </button>
                          <button
                            className="btn btn-secondary"
                            onClick={() => window.open(item.github)}
                          >
                            GitHub
                          </button>
                        </>
                      ) : (
                        <button
                          className="btn"
                          onClick={() => window.open(item.url)}
                        >
                          View
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Portfolio